import { VideoRange } from "@pcp/core/interfaces";

export class RangeValidator {

    constructor(private readonly range?: VideoRange) {
    }

    getIsInRange(seconds: number) {
        return this.getIsInLowerRange(seconds) && this.getIsInUpperRange(seconds);
    }

    getIsInLowerRange(seconds: number) {
        const rangeStart = this.range?.start;
        if (rangeStart !== undefined && Number.isFinite(rangeStart)) {
            return seconds >= rangeStart;
        }

        return true;
    }

    getIsInUpperRange(seconds: number) {
        const rangeEnd = this.range?.end;
        if (rangeEnd !== undefined && Number.isFinite(rangeEnd)) {
            return seconds <= rangeEnd;
        }

        return true;
    }

    getSecondsOrRangeLimit(seconds: number) {
        return this.getSecondsOrLowerRange(this.getSecondsOrUpperRange(seconds));
    }

    getSecondsOrLowerRange(seconds: number) {
        const rangeStart = this.range?.start;
        if (rangeStart !== undefined && Number.isFinite(rangeStart)) {
            return seconds < rangeStart ? rangeStart : seconds;
        }

        return seconds;
    }

    getSecondsOrUpperRange(seconds: number) {
        const rangeEnd = this.range?.end;
        if (rangeEnd !== undefined && Number.isFinite(rangeEnd)) {
            return seconds > rangeEnd ? rangeEnd : seconds;
        }

        return seconds;
    }
}
